export default __webpack_public_path__ + "static/media/cny-cart.23c0b313.webp";